import styled from "styled-components";

export const Container = styled.div`
	display: flex;

	width: 100%;
	height: 100%;

	background-color: #f5f5f5;

	font-family: "Mulish";

	justify-content: center;
`;

export const Content = styled.div`
	.coming-soon {
		display: flex;
		flex-direction: column;

		width: 75vw;
		height: 100%;

		justify-content: center;
		align-items: center;

		font-size: 2rem;
		font-family: "Mulish";

		color: #3751ff;

		img {
			width: 4rem;
		}
	}
	/* display: flex;
	flex-direction: column;

	width: 75vw;
	height: 100%;

	justify-content: space-around;
	align-items: center;

	.header {
		display: flex;

		width: 100%;
		height: 5%;

		gap: 0.5rem;

		p {
			font-size: 1.2rem;
			font-weight: 600;

			color: #252733;
		}

		#name {
			color: #2d7bbc;
		}
	}

	.top-wrapper {
		display: flex;

		width: 100%;
		height: 25%;

		justify-content: center;

		gap: 1%;

		.container {
			display: flex;

			width: 100%;
			height: 100%;

			border: 1px solid #ecedf5;
			border-radius: 0.4rem;

			padding: 1rem;

			background-color: white;

			@media (max-width: 768px) {
				width: 35%;
			}

			background-color: white;

			@media (max-width: 768px) {
				width: 35%;
			}

			.content {
				display: flex;
				flex-direction: column;

				width: 100%;
				height: 100%;

				#title {
					font-size: 1.2rem;
					font-weight: 600;
				}
			}
		}

		.reports-area {
			width: 100%;
			height: 100%;

			overflow: auto;
		}

		.reports-area::-webkit-scrollbar {
			width: 8px;
		}

		.reports-area::-webkit-scrollbar-thumb {
			background-color: #b7b7b7;

			border-radius: 0.5rem;
		}

		.report-wrapper {
			display: flex;

			width: 95%;
			height: 3.5rem;

			border-bottom: 2px solid #ecedf5;

			align-items: center;

			font-size: 1.2rem;

			cursor: pointer;
		}

		.report-wrapper:hover {
			background-color: #ecedf5;
		}

		.report-wrapper > p {
			color: #6f727e;

			margin: 0;
		}
	}

	.content-header {
		display: flex;

		width: 100%;
		height: 15%;

		align-items: center;
		justify-content: space-between;
	}

	#filter {
		width: 8rem;

		color: #8a8a8a;

		font-family: "Mulish";
		font-size: 1.2rem;

		background: none;

		border: none;
	}

	.main-container {
		display: flex;

		width: 100%;
		height: 60%;

		border: 1px solid #ecedf5;
		border-radius: 0.4rem;

		background-color: white;

		align-self: center;
	}

	.chart-wrapper {
		width: 100%;
		height: 100%;
	}

	#chart-wrapper {
		display: flex;
		flex-direction: column;

		width: 75%;
		height: 100%;
	}

	#header {
		display: flex;

		width: 100%;
		height: 10%;

		padding: 3rem;

		justify-content: space-between;
		align-items: center;
	}

	#header-text {
		display: flex;
		flex-direction: column;
	}

	#header-title {
		font-size: 1.2rem;
		font-weight: 600;

		color: black;
	}

	#header-day {
		font-size: 0.8rem;

		color: #9fa2b4;

		margin-top: 0.5rem;

		text-transform: capitalize;
	}

	#header-status {
		display: flex;

		width: 25%;

		justify-content: space-between;

		font-size: 0.8rem;
	}

	#analytic-data {
		width: 25%;
	}

	ul {
		width: 100%;
		height: 100%;

		list-style: none;
	}

	li {
		display: flex;
		flex-direction: column;

		width: 100%;
		height: 20%;

		align-items: center;
		justify-content: center;

		border: 1px solid #dfe0eb;
	}

	#li-title {
		color: #9fa2b4;

		font-weight: 600;
		font-size: 1.2rem;
	}

	#li-value {
		color: #252733;

		font-weight: 600;
		font-size: 1.2rem;
	} */
`;
